import { render, staticRenderFns } from "./PagesView.vue?vue&type=template&id=1af61a80"
import script from "./PagesView.vue?vue&type=script&lang=js"
export * from "./PagesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports